import window from "../../../lib/WindowExtended";
import {ProductList, ProductListOrder, ProductListOrderBy} from "@connox/typescript-library";
import {ProductListState} from "../ProductListProvider";

export const mapUrlParamsToFilterState = (
  stateForMap: ProductListState,
): {
  state: ProductListState;
  filters: {[k: string]: string};
} => {
  const tempState: ProductListState = {...stateForMap};
  const filters: {[k: string]: string} = {};
  const filtersItems = stateForMap.instance?.filter.filterItems;
  const usp = new URLSearchParams(window.location.search);
  usp.forEach((value, key) => {
    switch (key) {
      case "limit":
        tempState.limit = parseInt(value, 10);
        break;
      case "order":
        if (value === "innofind") {
          tempState.orderBy = value;
          tempState.order = "desc";
        } else {
          const [orderBy, order] = value.split("-");
          tempState.order = order as ProductListOrder;
          tempState.orderBy = orderBy as ProductListOrderBy;
        }
        break;
      default:
        if (filtersItems && filtersItems.has(key)) {
          filters[key] = value;
        }
    }
  });

  if (Object.keys(filters).length || tempState.orderBy) {
    tempState.showFilters = true;
  }
  if (!usp.has("limit")) {
    tempState.limit = ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
    tempState.offset = 0;
  }

  return {state: tempState, filters};
};
